unit View.Provedores.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, System.StrUtils, UUtils, UWeb.Enum,
  UPersonalizacao_Tabela, UPersonalizacao_Tabela.Interfaces;

type
  TFViewProvedoresList = class(TForm)
    btNew: TButton;
    ProvedoresDataset: TXDataWebDataSet;
    ProvedoresDatasetid: TIntegerField;
    ProvedoresDatasetnome: TStringField;
    ProvedoresDatasethomologado: TBooleanField;
    ProvedoresDatasetinclusao: TDateTimeField;
    ProvedoresDatasetalteracao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure WebFormShow(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewProvedoresList: TFViewProvedoresList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewProvedoresList }

procedure TFViewProvedoresList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewProvedoresList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewProvedoresList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewProvedoresList, AElementID, Result, @AfterCreate);
end;

procedure TFViewProvedoresList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewProvedoresList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewProvedoresList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewProvedoresList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewProvedoresList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'AÇÃO' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ProvedoresDataset.Connection.Model.DefaultSchema.FindEntityType(ProvedoresDataset.EntitySetName),
      ProvedoresDataset.CurrentData
    );


    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-edit"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_provedores');
  end;
end;

procedure TFViewProvedoresList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome']) of
      0 : AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewProvedoresList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['homologado']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewProvedoresList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('provedores', 'active');
  TUtils.SetValorDicionarioClasses('nfse_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_nfse', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    ProvedoresDataset,
    lcPaginator,
    lbPaginationInfo
  );

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewProvedoresList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(ProvedoresDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewProvedoresList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.provedores.list.pagination.info');
  btNew := TButton.Create('view.provedores.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.provedores.list.table');
  cbPageSize := TComboBox.Create('view.provedores.list.cbPageSize');
  edSearch := TEdit.Create('view.provedores.list.search');
  lcPaginator := TListControl.Create('view.provedores.list.pagination');
  ProvedoresDataset := TXDataWebDataSet.Create(Self);
  ProvedoresDatasetid := TIntegerField.Create(Self);
  ProvedoresDatasetnome := TStringField.Create(Self);
  ProvedoresDatasethomologado := TBooleanField.Create(Self);
  ProvedoresDatasetinclusao := TDateTimeField.Create(Self);
  ProvedoresDatasetalteracao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  ProvedoresDataset.BeforeLoadDFMValues;
  ProvedoresDatasetid.BeforeLoadDFMValues;
  ProvedoresDatasetnome.BeforeLoadDFMValues;
  ProvedoresDatasethomologado.BeforeLoadDFMValues;
  ProvedoresDatasetinclusao.BeforeLoadDFMValues;
  ProvedoresDatasetalteracao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewProvedoresList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#199#195'O';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#211'D.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'homologado';
      Title := 'homologado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'INCLUS'#195'O';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'ALTERA'#199#195'O';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    ProvedoresDataset.SetParentComponent(Self);
    ProvedoresDataset.Name := 'ProvedoresDataset';
    ProvedoresDataset.EntitySetName := 'Provedores';
    ProvedoresDataset.Connection := DMConnection.ApiConnection;
    ProvedoresDataset.Left := 72;
    ProvedoresDataset.Top := 144;
    ProvedoresDatasetid.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasetid.Name := 'ProvedoresDatasetid';
    ProvedoresDatasetid.FieldName := 'id';
    ProvedoresDatasetid.Required := True;
    ProvedoresDatasetnome.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasetnome.Name := 'ProvedoresDatasetnome';
    ProvedoresDatasetnome.FieldName := 'nome';
    ProvedoresDatasetnome.Required := True;
    ProvedoresDatasetnome.Size := 255;
    ProvedoresDatasethomologado.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasethomologado.Name := 'ProvedoresDatasethomologado';
    ProvedoresDatasethomologado.FieldName := 'homologado';
    ProvedoresDatasethomologado.Required := True;
    ProvedoresDatasetinclusao.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasetinclusao.Name := 'ProvedoresDatasetinclusao';
    ProvedoresDatasetinclusao.FieldName := 'inclusao';
    ProvedoresDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ProvedoresDatasetalteracao.SetParentComponent(ProvedoresDataset);
    ProvedoresDatasetalteracao.Name := 'ProvedoresDatasetalteracao';
    ProvedoresDatasetalteracao.FieldName := 'alteracao';
    ProvedoresDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ProvedoresDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    ProvedoresDataset.AfterLoadDFMValues;
    ProvedoresDatasetid.AfterLoadDFMValues;
    ProvedoresDatasetnome.AfterLoadDFMValues;
    ProvedoresDatasethomologado.AfterLoadDFMValues;
    ProvedoresDatasetinclusao.AfterLoadDFMValues;
    ProvedoresDatasetalteracao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
